import * as React from "react";
import type { SVGProps } from "react";

interface CornerProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Corner = ({ cancelled = false, ...props }: CornerProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#FFF"
        d="M10.1 1.56c.28.04.56.08.9.16l.36.1.62.16c1 .27 1.64.36 2.58.36.62 0 1.22-.08 1.75-.22l.46-.14c1.07-.28 2.17.3 2.57 1.39l.04.16.06.3.01.23v6.19c0 .85-.5 1.62-1.28 1.96l-.33.15a8.5 8.5 0 0 1-3.28.77c-1.06 0-1.8-.13-2.95-.5l-.92-.31c-.3-.1-.5-.15-.7-.18l-.22-.04-.17-.02c-.29-.04-.68-.05-1.15-.05H8.1v9.47c0 .37-.14.71-.39.97l-.11.1a1.4 1.4 0 0 1-2.3-1.07V3c0-.78.52-1.4 1.36-1.45l.45-.02.21-.01.04-.01.8-.02c.8 0 1.43.02 1.94.07"
      />
      <path
        fill="#000"
        d="M8.18 2.24c.75 0 1.36.02 1.84.07.25.03.5.07.8.14l.34.08.63.17c1.05.29 1.76.4 2.77.4.7 0 1.36-.1 1.97-.26l.43-.13c.69-.18 1.4.19 1.66.87l.04.14.03.16.01.18v6.19a1.4 1.4 0 0 1-.83 1.28l-.32.14c-1.1.46-2.1.7-2.99.7-.99 0-1.65-.1-2.71-.45l-.94-.32c-.32-.1-.55-.16-.8-.2l-.24-.04-.18-.03c-.32-.03-.74-.05-1.25-.05H7.9l-.55.03V21.5a.65.65 0 1 1-1.3 0V3c0-.36.2-.67.65-.7l.45-.02.2-.01.02-.01z"
      />
      <path
        fill="#007BBD"
        d="M9.88 3.6c.2.02.4.06.62.11l.32.08.63.17c1.1.3 1.92.43 3.11.43.94 0 1.85-.14 2.72-.42a.1.1 0 0 1 .11.05v6.22a.1.1 0 0 1-.05.1l-.3.13c-.96.4-1.79.6-2.48.6-.86 0-1.39-.1-2.3-.39l-.82-.27a8 8 0 0 0-1.4-.34l-.2-.03c-.5-.06-1.16-.07-1.99-.05l-.44.02V3.77l-.01-.2.01-.01h.14c1-.04 1.78-.02 2.33.04"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Corner;
